import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/views/Home.vue'
import NotFound from '@/views/NotFound.vue'
import Page from '@/views/Page.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/:lang',
            name: 'Home',
            component: Home
        },

        {
            path: '/:lang/wholesale',
            alias: ['/:lang/groothandel'],
            name: 'Wholesale',
            component: Page,
            meta: {
                single: true,
                handle: 'wholesale'
            }
        },

        {
            path: '/:lang/groothandel',
            name: 'WholesaleNL',
            component: Page,
            meta: {
                single: true,
                handle: 'wholesale'
            }
        },

        {
            path: '/:lang/vente-en-gros',
            name: 'WholesaleFR',
            component: Page,
            meta: {
                single: true,
                handle: 'wholesale'
            }
        },

        {
            path: '/:lang/retail',
            // alias: ['/:lang/retail'],
            name: 'Retail',
            component: Page,
            meta: {
                single: true,
                handle: 'retail'
            }
        },

        {
            path: '/:lang/product-range/:slug',
            alias: ['/:lang/assortiment/:slug'],
            name: 'ProductRange',
            component: Page,
            meta: {
                channel: true,
                handle: 'productRange'
            }
        },

        {
            path: '/:lang/jobs',
            name: 'JobsOverview',
            component: Page,
            meta: {
                single: true,
                handle: 'jobsOverview'
            }
        },

        {
            path: '/:lang/jobs/:slug',
            name: 'Jobs',
            component: Page,
            meta: {
                channel: true,
                handle: 'jobs'
            }
        },

        {
            path: '/:lang/404',
            name: 'NotFound',
            component: NotFound
        },

        {
            path: '/:lang/:slug',
            name: 'Page',
            component: Page
        }
    ],

    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
})
